import React from "react";
import "./style.scss";

const MarketplaceButton = ({
  title,
  isGradient,
  isBlue,
  onClick,
  isWhite,
  isNormal,
  disabled = false,
  withShadow,
  isAnimated,
  fullWidth = false,
  isGolden
}) => {
  return (
    <div
      onClick={onClick}
      style={{
        maxWidth: fullWidth ? 'unset' : undefined
      }}
      className={`
            marketplaceButton 
			${isGradient ? "marketplaceButton__gradient" : ""} 
			${isWhite ? "marketplaceButton__white" : ""} 
			${isBlue ? "marketplaceButton__blue" : ""}
			${isGolden ? "marketplaceButton__golden" : ""}
			${disabled ? "disabledEl" : ""}
			${withShadow ? "marketplaceButton__withShadow" : ""}
			${isAnimated ? "marketplaceButton__isAnimated" : ""}
            ${isNormal ? "marketplaceButton__isNormal" : ""}
			`}
    >
      {title}
    </div>
  );
};

export default MarketplaceButton;
